import {
  Typography
} from '@mui/material';
import Loading from "components/Loading";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { handleGetPlacementExamAssignedStatus } from "store/placement_exam/thunks";
import styled from "styled-components";
import { placement_exam_logo } from "utils/assets/images";
import { authHelper } from "utils/lib/authHelper";
import { useFirebase } from "containers/FirebaseContext";
import { decodeJwtPayload } from "utils/lib/jwtHelper";
import { handleVerifyAuth } from "store/userPreference/thunks";
import { goFullScreen } from "utils";
import { Modal, Button } from "antd";
import {ArrowBack} from '@mui/icons-material';
import * as Sentry from '@sentry/react';
import { handleAwsLogin } from 'utils/lib/auth';
import useTouchDetection from 'components/hooks/useTouchDeviceDetection';
import SentryWrap from 'components/Sentry';

const SubmitButton = styled.button`
  background-color: #00295c;
  color: #fff;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s ease;
  display: flex;
  flex-direction: row;
  &:hover {
    background-color: #011023;
  }

  &:disabled {
  background-color: #004c6d;
    cursor: not-allowed;
  }
`;
const AlertModal = ({ visible, onOk ,onOkAlert  }) => (
  <Modal
    open={visible}
    footer={null}
    onCancel={onOkAlert}
    className="studentQuestionModal"
  >
    <div className="stdntModalTxt" style={{ flexDirection: "column" }}>
      <p>✅ Código encontrado con éxito. Ahora puedes reanudar tu examen.</p>
    </div>
    <div style={{ textAlign: "right" }}>
      <Button onClick={onOk} className="next-button">Bueno</Button>
    </div>
  </Modal>
);
const BackButton = styled.button`
   background: none;
   border: none;
   cursor: pointer;
   display: flex;
   align-items:center;
   font-size:16px;
   color:#fff;
   position:absolute;
   left:6px;
   top:6px;
`;
const PlacementExamCode = () => {
  const location = useLocation();
  							  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState();
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [placeholder, setPlaceholder] = useState("Enter code");
  const firebaseContex = useFirebase();
  const isTouchDevice = useTouchDetection();
  const [alertModal,setAlertModal] = useState({
    open:false,
    session_id:'',
    currentSectionIndex:'', 
    currentQuestionIndex:''
  })
  const handleFocus = () => {
    setPlaceholder("");
  };

  const handleBlur = () => {
    if (!code) {
      setPlaceholder("Enter code");
    }
  };

  const placementExamCode = () => {
    navigate("/placement-exam/form?tab=form")
  }
  const authenticateUser = async () => {
    try {
      let awsLogin = null;
        const resetResponse = await handleVerifyAuth('schoologyAuth', 'placement_exam', 'PlacementExam');
        if (resetResponse && resetResponse.success && resetResponse.data?.token) {
            const decoded = decodeJwtPayload(resetResponse.data.token);
            if (decoded && decoded.username && decoded.password) {
                const auth_config = authHelper({
                    username: decoded.username,
                    password: decoded.password,
                });
               awsLogin = await handleAwsLogin(auth_config);
               if(awsLogin && awsLogin.isSignedIn){
                await firebaseContex.signInWithCustomTokenApi(decoded.username);
               }
            }
        }
        return awsLogin;
    } catch (error) {
        Sentry.captureException(`109 Error during Firebase authenticateUser ${error}.`);
        throw error;
    }
  }
  const redirectToExam = async (session_id, currentSectionIndex, currentQuestionIndex) => {
    const awsLogin = await authenticateUser()
    if(!awsLogin || !awsLogin.isSignedIn){
      setError('Authentication failed. Please try login again!');
      return;
    }
    setAlertModal({
      open:true,
      session_id,
      currentSectionIndex,
      currentQuestionIndex
    });
  }
  useEffect(()=>{
    sessionStorage.removeItem("exam_dist_logo"); 
    sessionStorage.removeItem("time_to_calc");
    sessionStorage.removeItem("shown_video");
    sessionStorage.removeItem("switch_tab_count");
 },[])
  const fetchPlacementExamByCode = async () => {
    if (code) {
      setLoading(true)
      try {
        if (code) {
          const data = await dispatch(handleGetPlacementExamAssignedStatus(code))
          if (data && data.success && data.status_code=='200') {
            if(data?.data?.assignment?.is_archived){
              setError('This code is currently unavailable. Please use another one.');
              return;
            }
            placementExamCode()
          } else if(data && data.success && data.status_code=='205'){

             const { answers , session_info , exam_info } = data.data;
             if(Array.isArray(answers)){
              try {
                const currentSectionIndex = answers.length ? answers.length - 1 : 0;
                const currentQuestionIndex = answers[currentSectionIndex]?.length ? answers[currentSectionIndex].length - 1 : 0;
                const las_question = answers?.[currentSectionIndex]?.[currentQuestionIndex] || {};
                
                if (las_question?.running_time) {
                  sessionStorage.setItem("remainingTime", las_question.running_time);
                }
                
                sessionStorage.setItem("exam_dist_logo", exam_info?.config?.logo || '');
                await redirectToExam(session_info.id, currentSectionIndex, currentQuestionIndex);
              } catch (err) {
                console.error('Error before done:', err);
              }
              
             }
          }
            else {
            setError(data.message || 'Something went wrong!')
          }
        }
      } catch (error) {
        Sentry.captureException(`486 Error in fetchPlacementExamByCode: ${error}`);
      } finally {
        setLoading(false)
      }
    }
  }
  const onValueChaneg = (e) => {
    if(typeof e.target.value =="string"){
      setCode(e.target.value.trim());
      setError('')
    }
  }
  const onOkAlert = () =>{
    if(!isTouchDevice){
       goFullScreen()
    }
    navigate(`/placement-exam/exam?session_id=${alertModal.session_id}&section=${alertModal.currentSectionIndex}&question=${alertModal.currentQuestionIndex}`);
    setAlertModal({
      open:false,
      session_id:'',
      currentSectionIndex:'',
      currentQuestionIndex:''
    })
  }
  return (
  <SentryWrap>
    <div className="placementCodecontainer">
      <AlertModal visible={alertModal.open} onOk={onOkAlert} onCancle={onOkAlert} />
      {/* Left Section */}
      <div className="placementCodeLft">
      <div style={{ padding: "10px" }}>
      <BackButton
        onClick={() => navigate(-1)}
      >
        <ArrowBack style={{ marginRight: "5px" }} /> Back
      </BackButton>
    </div>
        <img src={placement_exam_logo} onClick={()=>navigate("/login")} style={{ cursor:"pointer"}}/>
      </div>

      {/* Right Section */}
      <div className="placementCodeRgt">
        <p className="placementCodeInstraction">Type the code shared <br /> by your administrator</p>
        <input type="number" placeholder={placeholder} className="placementExamInput" onChange={onValueChaneg} value={code} 
         onFocus={handleFocus}
         onBlur={handleBlur} 
         onKeyDown={(e) => {
          if (e.key === "Enter" && code && !loading) {
            fetchPlacementExamByCode();
          }
        }}
         />
        {error ? <Typography variant="subtitle2" style={{ whiteSpace: "pre-wrap", textAlign: "center", padding: "0px 0px 15px 0px" }} color="error">
          {error}
        </Typography>
          : null}
        <SubmitButton
          disabled={!code || loading}
          className="placementCodeSubBtn"
          onClick={fetchPlacementExamByCode}>
          {loading ? <Loading size={16} white={true} /> : null} Submit
        </SubmitButton>
      </div>
    </div>
  </SentryWrap>
  );
};

export default PlacementExamCode;






